<template>
  <master-layout pageTitle="Test Page">
    <div class="center-align">
      <upload-files-v-2 type="image" :multiple="false" id="'headerImage'" ref="headerImage" :maxFileSizeAllowed="4" v-model:loading="image.uploading" @send-upload-data="handleImageUpload">
        <img v-if="image.url" :src="image.url" />
        <ion-button v-else>Upload Image</ion-button>
      </upload-files-v-2>
      <upload-files-v-2 type="video" :multiple="false" id="'headerVideo'" ref="headerVideo" :maxFileSizeAllowed="200" v-model:loading="video.uploading" @send-upload-data="handleVideoUpload" :testType="1">
        <video v-if="video.url" :src="video.url" />
        <ion-button v-else>Upload Video</ion-button>
      </upload-files-v-2>
      <upload-files-v-2 type="video" :multiple="false" id="'headerVideo2'" ref="headerVideo2" :maxFileSizeAllowed="200" v-model:loading="video2.uploading" @send-upload-data="handleVideoUpload2" :testType="2">
        <video v-if="video2.url" :src="video2.url" />
        <ion-button v-else>Upload Video 2</ion-button>
      </upload-files-v-2>
      <upload-files-v-2 type="video" :multiple="false" id="'headerVideo3'" ref="headerVideo3" :maxFileSizeAllowed="200" v-model:loading="video3.uploading" @send-upload-data="handleVideoUpload3" :testType="3">
        <video v-if="video3.url" :src="video3.url" />
        <ion-button v-else>Upload Video 3</ion-button>
      </upload-files-v-2>
      <upload-files-v-2 type="document" :multiple="false" id="'headerDoc'" ref="headerDoc" :maxFileSizeAllowed="4" v-model:loading="document.uploading" @send-upload-data="handleDocUpload">
        <a v-if="document.url" :href="document.url" target="_blank">Download</a>
        <ion-button v-else>Upload Document</ion-button>
      </upload-files-v-2>
    </div>
  </master-layout>
</template>
  
<script>
import uploadFilesV2 from '@/components/uploadFilesV2.vue';
import { useUIStore } from '@/stores/ui';

export default {
  components: { uploadFilesV2 },
  data() {
    return {
      image: {
        uploading: false,
        url: undefined,
        filename: undefined
      },
      video: {
        uploading: false,
        url: undefined,
        filename: undefined
      },
      video2: {
        uploading: false,
        url: undefined,
        filename: undefined
      },
      video3: {
        uploading: false,
        url: undefined,
        filename: undefined
      },
      document: {
        uploading: false,
        url: undefined,
        filename: undefined
      }
    }
  },
  methods: {
    async handleImageUpload (urlData) {
      try {
        this.image.uploading = true;
        this.image.url = urlData[0].url;
        this.image.filename = urlData[0]?.filename;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.image.uploading = false;
      }
    },
    async handleVideoUpload (urlData) {
      try {
        this.video.uploading = true;
        this.video.url = urlData[0].url;
        this.video.filename = urlData[0]?.filename;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.video.uploading = false;
      }
    },
    async handleVideoUpload2 (urlData) {
      try {
        this.video2.uploading = true;
        this.video2.url = urlData[0].url;
        this.video2.filename = urlData[0]?.filename;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.video2.uploading = false;
      }
    },
    async handleVideoUpload3 (urlData) {
      try {
        this.video3.uploading = true;
        this.video3.url = urlData[0].url;
        this.video3.filename = urlData[0]?.filename;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.video3.uploading = false;
      }
    },
    async handleDocUpload (urlData) {
      try {
        this.document.uploading = true;
        this.document.url = urlData[0].url;
        this.document.filename = urlData[0]?.filename;
      } catch (error) {
        console.error("Exception: ", error);
        useUIStore().updateToast({
          open: true,
          message: "Something went wrong",
          type: "danger"
        })
      } finally {
        this.document.uploading = false;
      }
    }
  }
}
</script>
  
<style scoped>
.center-align {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>